import {
  COMPONENT_VALUE_TYPES as types,
} from 'shared/constants';

const propsSchema = [
  {
    key: 'video_src',
    label: 'Video Source',
    type: types.TEXT
  },
  {
    key: 'poster',
    label: 'Poster',
    type: types.TEXT
  },
  {
    key: 'options',
    label: 'Player Options',
    type: types.OBJECT,
    children: [
      {
        type: types.BOOLEAN,
        key: 'autoplay',
        label: 'Autoplay (may not work if video is not muted)',
      },
      {
        type: types.BOOLEAN,
        key: 'muted',
        label: 'Muted',
      },
      {
        key: 'live',
        label: 'Live',
        type: types.BOOLEAN
      },
      {
        key: 'width',
        label: 'Width',
        type: types.TEXT
      },
      {
        key: 'height',
        label: 'Height',
        type: types.TEXT
      },
    ]
  },
];

const defaultProps = {
  video_src: '',
  poster: '',
  options: {
    autoplay: true,
    muted: true,
    live: false,
    width: '',
    height: ''
  }
};

export default {
  title: 'Livestream TC Player',
  id: 'LivestreamTcPlayer',
  propsSchema,
  defaultProps
};
